export default __webpack_public_path__ + "static/media/miscellaneous19.4c6d2a90.png";